/** A yes/no question on the shared Modal, for actions worth a second look. */

import type { ReactNode } from 'react';

import { ActionButton } from '@/ui/ActionButton';
import { Modal } from '@/ui/Modal';
import { FormError } from '@/ui/StateCard';

export function ConfirmDialog({
  title,
  confirmLabel,
  danger = false,
  pending = false,
  error,
  onConfirm,
  onClose,
  children,
}: {
  title: string;
  confirmLabel: string;
  danger?: boolean;
  pending?: boolean;
  error?: unknown;
  onConfirm: () => void;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <Modal
      title={title}
      size="narrow"
      onClose={onClose}
      onSubmit={onConfirm}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <ActionButton
            state={{ pending, error }}
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
            label={confirmLabel}
            pendingLabel="Working…"
            autoFocus
          />
        </>
      }
    >
      <div className="stack-md">
        <FormError error={error} />
        {children}
      </div>
    </Modal>
  );
}
